import { ConfigInterface } from 'swr';
import { parseUrl, useWPAcfV3Api, wpAcfV3Api } from '@gik/core/api';
import { IWordpressGikSettings } from '@gik/core/models/wordpress/WordPressGikSettings';

const path = 'options/options';

export function getGikSettings() {
  const finalUrl = parseUrl(path, {});
  return wpAcfV3Api.get(finalUrl);
}

export function useGikSettings(config?: ConfigInterface) {
  return useWPAcfV3Api<IWordpressGikSettings>(path, config, {});
}
